/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EmailLogIncludeFilterItems } from './emailLogIncludeFilterItems';
import { EmailLogScopeFilter } from './emailLogScopeFilter';


export interface EmailLogIncludeFilterInner { 
    relation?: EmailLogIncludeFilterInner.RelationEnum;
    scope?: EmailLogScopeFilter;
}
export namespace EmailLogIncludeFilterInner {
    export type RelationEnum = 'email';
    export const RelationEnum = {
        Email: 'email' as RelationEnum
    };
}


